import { dashboardStore } from '../stores'

export const validatePermission = (permission: string): boolean => {
    const permissions: string[] = dashboardStore.getState()?.userData?.user_details?.role?.permissions
    if (!permissions) {
        return false
    }
    return permissions.includes(permission)
}
